import React from 'react';
import { Link } from 'react-router-dom';
import { LifeBuoy, Wrench, Phone, ShieldCheck, ExternalLink } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { SEO } from '../components/SEO';
import { FreezeDryerSupport } from '../components/FreezeDryerSupport';
import { WarrantyClaimForm } from '../components/WarrantyClaimForm';
import { RebuildWarranty } from '../components/RebuildWarranty';
import { OwnerManuals } from '../components/OwnerManuals';
import { CONTACT, SUPPORT } from '../lyphline';

const TechnicalSupport = () => (
  <div className="min-h-screen bg-white" data-testid="technical-support-page">
    <SEO
      title="Technical Support & Warranty"
      description="Get technical support for your freeze dryer, register your machine and submit warranty claims through Freeze Dryer Support. Call LyphLine or start a free diagnostic."
      keywords="freeze dryer technical support, freeze dryer warranty claim, register freeze dryer, freeze dryer support, freezedryersupport.com"
    />
    <Navbar />

    {/* Hero */}
    <section className="pt-32 pb-16 section-padding bg-[#003456]" data-testid="support-hero">
      <div className="max-w-7xl mx-auto">
        <span className="inline-flex items-center gap-2 text-[#CE8946] font-semibold text-xs uppercase tracking-[0.2em]">
          <LifeBuoy className="h-4 w-4" /> Technical Support
        </span>
        <h1 className="text-4xl sm:text-5xl font-extrabold text-white mt-4 max-w-3xl leading-tight">
          Support for your machine, whenever you need it
        </h1>
        <p className="text-white/70 mt-5 max-w-2xl text-lg">
          Machine registration and warranty claims are handled through <strong className="text-white">Freeze Dryer Support</strong>,
          our dedicated support portal. Need a hand right now? Call us or start a free diagnostic and we'll help you get back online.
        </p>
        <div className="flex flex-col sm:flex-row flex-wrap gap-3 mt-8">
          <a href={SUPPORT.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#CE8946] hover:bg-[#B87333] text-[#003456] font-bold px-7 py-4 rounded-md transition-colors" data-testid="support-hero-portal">
            <ShieldCheck className="h-5 w-5" /> Freeze Dryer Support <ExternalLink className="h-4 w-4" />
          </a>
          <Link to="/repair/quote" className="inline-flex items-center justify-center gap-2 border border-white/25 text-white font-semibold px-7 py-4 rounded-md hover:bg-white/10 transition-colors" data-testid="support-hero-diagnostic">
            <Wrench className="h-5 w-5" /> Start a Free Diagnostic
          </Link>
          <a href={CONTACT.phoneHref} className="inline-flex items-center justify-center gap-2 border border-white/25 text-white font-semibold px-7 py-4 rounded-md hover:bg-white/10 transition-colors" data-testid="support-hero-call">
            <Phone className="h-5 w-5 text-[#CE8946]" /> {CONTACT.phone}
          </a>
        </div>
        <p className="text-white/50 text-sm mt-5">{CONTACT.hours} &middot; {CONTACT.serviceArea}</p>
      </div>
    </section>

    {/* Freeze Dryer Support — the hero element of the page */}
    <FreezeDryerSupport bg="bg-[#023F63]" testid="support-fds" />

    {/* Owner manuals & guides */}
    <OwnerManuals bg="bg-white" testid="support-manuals" />

    {/* Warranty overview */}
    <RebuildWarranty bg="bg-[#F1F5F9]" testid="support-warranty" />

    {/* On-site quick claim capture */}
    <WarrantyClaimForm bg="bg-white" testid="support-claim-form" />

    <Footer />
  </div>
);

export default TechnicalSupport;
